module.exports = __webpack_public_path__ + "static/media/code.a95e9bf6.svg";